// extracted by mini-css-extract-plugin
module.exports = {"bar":"LoginAsBar_bar__2s5cr","link":"LoginAsBar_link__28mLn","userName":"LoginAsBar_userName__kpu5o","text":"LoginAsBar_text__31G-G"};